<template>
  <el-row :gutter="12">
    <el-col :span="24">
      <el-form-item
        class="formItem"
        label="Thứ tự sắp xếp"
      >
        <el-select
          filterable
          clearable
          v-model="sortList"
          multiple
          size=""
          placeholder="Tên thứ tự tìm kiếm"
          class="style-fullWidth input-border__bottom input-border__radius__0"
          @change="changeChoose"
        >
          <el-option
            v-for="item in sortLists"
            :key="item.id"
            :label="showUpDownText(item)"
            :value="item.sortData"
          >
            <!--              {{showUpDownText(item)}}-->
            <span> {{showUpDownIcon(item)}}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "vbden-sort-select",
  props: ["form"],
  mounted() {
    this.loadSort();
  },
  methods: {
    loadSort() {
      if (this.form.sortList) {
        this.sortList = this.form.sortList;
        this.changeChoose();
      }
    },
    resetData(){
      this.sortList=[];
    },
    showUpDownIcon(item) {
      if (item.sortData.includes("priorityName")) {
        if (item.sortData.includes('desc')) {
          return item.name + " (Khẩn -> Hỏa tốc -> Bình thường)";
        } else {
          return item.name + " (Bình thường -> Hỏa tốc -> Khẩn)";
        }
      } else {
        if (item.sortData.includes('desc')) {
          return item.name + " (z -> a)";
        } else {
          return item.name + " (a -> z)";
        }
      }

      // if(item.sortData.includes('desc')){
      //   return `(<i class="fas fa-arrow-down "></i>)`;
      // }
      // else {
      //   return `(<i class="fas fa-arrow-up"></i>)`;
      // }
    },
    showUpDownText(item) {
      if (item.sortData.includes("priorityName")) {
        if (item.sortData.includes('desc')) {
          return item.name + " (Khẩn -> Hỏa tốc -> Bình thường)";
        } else {
          return item.name + " (Bình thường -> Hỏa tốc -> Khẩn)";
        }
      } else {
        if (item.sortData.includes('desc')) {
          return item.name + " (z -> a)";
        } else {
          return item.name + " (a -> z)";
        }
      }

      // if(item.sortData.includes('desc')){
      //   return item.name+ " (giảm dần)";
      // }
      // else {
      //   return item.name+ " (tăng dần)";
      // }
    },
    changeChoose() {
      this.$emit("selectedSort", {sortList: this.sortList});
    }
  },
  data() {
    return {
      sortList: [],
      sortLists: [{
        id: "1",
        name: "Mức độ khẩn",
        sortData: "priorityName,desc"
      },
        {
          id: "2",
          name: "Mức độ khẩn",
          sortData: "priorityName,asc"
        },
        {
          id: "3",
          name: "Nơi ban hành",
          sortData: "publisherName,desc",

        }
        ,
        {
          id: "4",
          name: "Nơi ban hành",
          sortData: "publisherName,asc",

        }
      ]
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/common/vbden-sort-select.vue